import { render, staticRenderFns } from "./ViewCommission.vue?vue&type=template&id=0d7bd9a7&"
import script from "./ViewCommission.vue?vue&type=script&lang=js&"
export * from "./ViewCommission.vue?vue&type=script&lang=js&"
import style0 from "./ViewCommission.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports